/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecipientProviderStatus } from './RecipientProviderStatus';
import {
    RecipientProviderStatusFromJSON,
    RecipientProviderStatusFromJSONTyped,
    RecipientProviderStatusToJSON,
} from './RecipientProviderStatus';
import type { RecipientResolutionCandidate } from './RecipientResolutionCandidate';
import {
    RecipientResolutionCandidateFromJSON,
    RecipientResolutionCandidateFromJSONTyped,
    RecipientResolutionCandidateToJSON,
} from './RecipientResolutionCandidate';

/**
 * 
 * @export
 * @interface ReferralRecipientConfig
 */
export interface ReferralRecipientConfig {
    /**
     * 
     * @type {number}
     * @memberof ReferralRecipientConfig
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ReferralRecipientConfig
     */
    sender_facility_id: number;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    provider_id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    provider_type?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    provider_name: string;
    /**
     * True when the recipient's provider is an external (non-ExaCare) directory row, or when it's an "other" recipient. External recipients require an email address.
     * @type {boolean}
     * @memberof ReferralRecipientConfig
     */
    is_external: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    display_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    notes?: string;
    /**
     * 
     * @type {RecipientProviderStatus}
     * @memberof ReferralRecipientConfig
     */
    provider_status?: RecipientProviderStatus;
    /**
     * 
     * @type {string}
     * @memberof ReferralRecipientConfig
     */
    ccn?: string;
    /**
     * 
     * @type {Array<RecipientResolutionCandidate>}
     * @memberof ReferralRecipientConfig
     */
    resolution_candidates?: Array<RecipientResolutionCandidate>;
}

/**
 * Check if a given object implements the ReferralRecipientConfig interface.
 */
export function instanceOfReferralRecipientConfig(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "sender_facility_id" in value;
    isInstance = isInstance && "provider_name" in value;
    isInstance = isInstance && "is_external" in value;

    return isInstance;
}

export function ReferralRecipientConfigFromJSON(json: any): ReferralRecipientConfig {
    return ReferralRecipientConfigFromJSONTyped(json, false);
}

export function ReferralRecipientConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralRecipientConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sender_facility_id': json['sender_facility_id'],
        'provider_id': !exists(json, 'provider_id') ? undefined : json['provider_id'],
        'provider_type': !exists(json, 'provider_type') ? undefined : json['provider_type'],
        'provider_name': json['provider_name'],
        'is_external': json['is_external'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'display_name': !exists(json, 'display_name') ? undefined : json['display_name'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'provider_status': !exists(json, 'provider_status') ? undefined : RecipientProviderStatusFromJSON(json['provider_status']),
        'ccn': !exists(json, 'ccn') ? undefined : json['ccn'],
        'resolution_candidates': !exists(json, 'resolution_candidates') ? undefined : ((json['resolution_candidates'] as Array<any>).map(RecipientResolutionCandidateFromJSON)),
    };
}

export function ReferralRecipientConfigToJSON(value?: ReferralRecipientConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sender_facility_id': value.sender_facility_id,
        'provider_id': value.provider_id,
        'provider_type': value.provider_type,
        'provider_name': value.provider_name,
        'is_external': value.is_external,
        'address': value.address,
        'display_name': value.display_name,
        'email': value.email,
        'phone': value.phone,
        'notes': value.notes,
        'provider_status': RecipientProviderStatusToJSON(value.provider_status),
        'ccn': value.ccn,
        'resolution_candidates': value.resolution_candidates === undefined ? undefined : ((value.resolution_candidates as Array<any>).map(RecipientResolutionCandidateToJSON)),
    };
}

